<script lang="ts">
  import { Ingresos, Signos, type Ingreso } from '../../../lib/api';

  type Pendiente = { cama?: string; pacienteId: string; pacienteLabel: string; hace: string };

  let { limit = 8, onNavigate }: { limit?: number; onNavigate?: (tab: string) => void } = $props();
  let items = $state<Pendiente[]>([]);
  let error = $state<string | null>(null);

  const HORAS_LIMITE = 4;

  function hace(iso?: string | null): string {
    if (!iso) return 'sin registro';
    const h = (Date.now() - new Date(iso).getTime()) / 3_600_000;
    if (h < 1) return `hace ${Math.round(h * 60)} min`;
    return `hace ${Math.round(h)} h`;
  }

  async function cargar() {
    error = null;
    try {
      const ingresos = (await Ingresos.activos()).slice(0, 20) as Ingreso[];
      const pendientes: Pendiente[] = [];
      for (const ing of ingresos) {
        const signos = await Signos.porPaciente(ing.pacienteId).catch(() => []);
        const ultimo = signos.sort((a, b) =>
          (b.registradoEn ?? '').localeCompare(a.registradoEn ?? ''))[0];
        const antiguo = !ultimo?.registradoEn
          || (Date.now() - new Date(ultimo.registradoEn).getTime()) > HORAS_LIMITE * 3_600_000;
        if (antiguo) {
          pendientes.push({
            cama: ing.camaId?.slice(0, 8),
            pacienteId: ing.pacienteId,
            pacienteLabel: ing.diagnosticoIngreso ?? ing.pacienteId.slice(0, 8),
            hace: hace(ultimo?.registradoEn),
          });
        }
        if (pendientes.length >= limit) break;
      }
      items = pendientes;
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => { cargar(); const t = setInterval(cargar, 60000); return () => clearInterval(t); });
</script>

<div class="panel">
  <header>
    <h3>Signos atrasados</h3>
    <button type="button" onclick={cargar}>↻</button>
  </header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if items.length === 0 && !error}
    <p class="empty">Sin signos atrasados (&gt;{HORAS_LIMITE}h).</p>
  {:else}
    <ul>
      {#each items as it, i (i)}
        <li>
          <div>
            <strong>{it.pacienteLabel}</strong>
            <span>Último control: {it.hace}</span>
          </div>
          {#if onNavigate}
            <button type="button" class="link" onclick={() => onNavigate('signos')}>Registrar</button>
          {/if}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--glass-border); border-radius: var(--radius-xl); background: var(--glass-bg-card); backdrop-filter: var(--glass-blur); -webkit-backdrop-filter: var(--glass-blur); box-shadow: var(--glass-shadow); overflow: hidden; height: 100%; }
  header { display: flex; justify-content: space-between; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--glass-border); background: rgba(255,255,255,0.35); backdrop-filter: blur(8px); -webkit-backdrop-filter: blur(8px); }
  h3 { margin: 0; font-size: 0.88rem; font-weight: 700; }
  header button { border: 1px solid var(--glass-border); background: var(--glass-bg-card); border-radius: 999px; cursor: pointer; padding: 0.2rem 0.55rem; font-weight: 600; transition: all 0.2s; }
  header button:hover { background: var(--brand-surface); border-color: var(--brand-strong); color: var(--brand-deep); }
  ul { list-style: none; margin: 0; padding: 0; max-height: 280px; overflow: auto; }
  li { display: flex; justify-content: space-between; gap: 0.5rem; align-items: center; padding: 0.6rem 0.85rem; border-bottom: 1px solid var(--glass-border); transition: background 0.15s; }
  li:hover { background: rgba(255,255,255,0.35); }
  strong { display: block; font-size: 0.85rem; }
  span { font-size: 0.78rem; color: var(--text-secondary); }
  .link { border: 0; background: transparent; color: var(--brand-strong); font-size: 0.78rem; cursor: pointer; font-weight: 600; }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
</style>
